import { Modal, ModalProps } from '../../../../../../../components/modal/modal';
import { Stepper } from '../../../../../../../components/stepper/stepper';
import { MenuInformerCreateDishModalStep1 } from './menu-informer-create-dish-modal-step-1/menu-informer-create-dish-modal-step-1';
import { MenuInformerCreateDishModalStep2 } from './menu-informer-create-dish-modal-step-2/menu-informer-create-dish-modal-step-2';
import s from './menu-informer-create-dish-modal.module.css';
// import { CreateDishModalStep3 } from './create-dish-modal-step-3/create-dish-modal-step-3';
import { Button } from '../../../../../../../components/button/button';
import { MenuInformerCreateDishModalStep4 } from './menu-informer-create-dish-modal-step-4/menu-informer-create-dish-modal-step-4';
import { useMenuInformerCreateDishModal } from './use-menu-informer-create-dish-modal';

const stepComponents = [
  <MenuInformerCreateDishModalStep1 />,
  <MenuInformerCreateDishModalStep2 />,
  // <CreateDishModalStep3 />,
  <MenuInformerCreateDishModalStep4 />,
];

export const MenuInformerCreateDishModal = (props: ModalProps) => {
  const { handleNextStep, handlePrevStep, step, t, isLoading } = useMenuInformerCreateDishModal(props);

  return (
    <Modal {...props} className={s.feature} title={t('Параметры позиции')} withLang>
      <Stepper current={step} totalSteps={stepComponents.length} />
      {stepComponents[step]}
      <div className={s.controls}>
        <Button onClick={handlePrevStep} variant="secondary" data-testid="cancel-button">
          {t(stepComponents.length - step >= stepComponents.length ? 'Отменить' : 'Назад')}
        </Button>
        <Button onClick={handleNextStep} disabled={isLoading} data-testid="submit-button">
          {t(step >= stepComponents.length - 1 ? 'Сохранить' : 'Далее')}
        </Button>
      </div>
    </Modal>
  );
};
